module.exports = __webpack_public_path__ + "img/help_download.afee7f82.png";